import React from "react";
import styles from "./topCourseRiskCard.module.css";
import WarningCircleIcon from "../../../assets/icons/warning-circle.svg";

const TopCourseRiskCard = ({ classPredictions = [], topFactors = [] }) => {
  // Encontrar o curso com maior porcentagem de inadimplência
  const getTopRiskCourse = () => {
    if (!classPredictions || classPredictions.length === 0) {
      return null;
    }

    // Ordenar por maior porcentagem de inadimplência prevista
    const sortedClasses = [...classPredictions]
      .filter(cls => cls.predictedDelinquencyPct > 0)
      .sort((a, b) => b.predictedDelinquencyPct - a.predictedDelinquencyPct);

    return sortedClasses[0] || null;
  };

  // Traduzir fatores de risco para português usando REASON_ALLOWLIST
  const translateFactor = (factor) => {
    const REASON_ALLOWLIST = {
      "AttendanceAvg_1m": { text: "Frequência baixa no último mês", tag: "Baixa" },
      "AttendanceBelowThresholdCount_1m": { text: "Várias aulas abaixo do limite de frequência", tag: "Baixa" },
      "FinalGradeAvg_1m": { text: "Média de notas baixa", tag: "Baixa" },
      "IntermediateGradeAvg_1m": { text: "Notas intermediárias baixas", tag: "Baixa" },
      "FinalExamMissingCount_1m": { text: "Faltas em provas finais", tag: "Alta" },
      "TotalHours_1m": { text: "Carga horária elevada", tag: "Alta" },
      "ShareEAD_1m": { text: "Muita carga EAD", tag: "Alta" },
      "ShareNightShift_1m": { text: "Muitas aulas no noturno", tag: "Alta" },
      "DaysSinceLastPayment": { text: "Período desde o último pagamento", tag: "Muitos Dias" },
      "ReceivedToBilledRatio_1m": { text: "Recebido/Boleto do mês", tag: "Baixo" },
      "ReceivedToBilledRatio_3m": { text: "Recebido/Boleto em 3m", tag: "Baixo" },
      "ReceivedAmount_1m": { text: "Valor recebido no mês", tag: "Baixo" },
      "BilledAmount_1m": { text: "Mensalidade do último mês", tag: "Alta" },
      "BilledAmount_3m": { text: "Média da mensalidade nos últimos três meses", tag: "Alta" }
    };

    // Se não encontrar tradução no REASON_ALLOWLIST, formatar o nome automaticamente
    const translated = REASON_ALLOWLIST[factor];
    if (translated) {
      return translated;
    }
    const formattedName = factor.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
    return { text: formattedName, tag: "" };
  };

  // Obter os principais fatores de risco
  const getTopRiskFactors = () => {
    if (!topFactors || topFactors.length === 0) {
      return [];
    }

    return topFactors
      .slice(0, 3) // Pegar os 3 principais fatores
      .map(factor => {
        const translated = translateFactor(factor.feature);
        return {
          text: translated.text,
          tag: translated.tag,
          weight: (factor.avgWeight * 100).toFixed(1)
        };
      });
  };

  const topRiskCourse = getTopRiskCourse();
  const mainRiskFactors = getTopRiskFactors();

  if (!topRiskCourse) {
    return (
      <div className={styles.topCourseRiskCardWrapper}>
        <div className={styles.topCourseRiskCardHeader}>
          <h3>Curso com Maior Risco de Inadimplência</h3>
        </div>
        <div className={styles.noDataMessage}>
          <p>Nenhum dado de curso disponível</p>
        </div>
      </div>
    );
  }


  return (
    <div className={styles.topCourseRiskCardWrapper}>
      <div className={styles.topCourseRiskCardHeader}>
        <h3>Maior Risco de Inadimplência • Cursos</h3>
      </div>
      
      <div className={styles.topCourseRiskCardBody}>
        <div className={styles.courseInfoSection}>
          <div className={styles.courseName}>
            {topRiskCourse.className}
          </div>
          <div className={styles.predictionBadge}>
            <span className={styles.badgeLabel}>Previsão de Inadimplentes:</span>
            <span className={styles.badgeValue}>{topRiskCourse.predictedDelinquents}</span>
          </div>
        </div>

        {mainRiskFactors.length > 0 && (
          <div className={styles.riskFactors}>
            <h4>Principais Fatores de Risco:</h4>
            <div className={styles.factorsList}>
              {mainRiskFactors.map((factor, index) => (
                <div key={index} className={styles.factorCard}>
                  <img src={WarningCircleIcon} alt="Alerta" className={styles.factorIcon} />
                  <div className={styles.factorCardContent}>
                    <span className={styles.factorName}>
                      {factor.text} • <span className={styles.factorTag}>{factor.tag}</span>
                    </span>
                  </div>
                  <span className={styles.factorWeight}>{factor.weight}%</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopCourseRiskCard;
